export enum ProductSize{
    XS = "XS",
    S = "S", 
    M = "M",
    L = "L",
    XL = "XL",
    XXL = "XXL",
    NORMAL = "NORMAL",
    LARGE = "LARGE",
    SMALL = "SMALL"
}

export enum ProductVolume{
    HOME = "HOME",
    AWAY = "AWAY", 
    THIRD = "THIRD",
    TRAINING = "TRAINING",
    SPECIAL = "SPECIAL",
    VOLUME_1 = "1",
    VOLUME_1_2 = "1.2",
    VOLUME_0_5 = "0.5",
    VOLUME_2 = "2"
}

export enum ProductStatus {
    PAUSE = "PAUSE",
    PROCESS = "PROCESS",
    DELETE = "DELETE",
}

export enum ProductCollection {
    PREMIER_LEAGUE = "PREMIER_LEAGUE",
    LA_LIGA = "LA_LIGA",
    SERIE_A = "SERIE_A",
    BUNDESLIGA = "BUNDESLIGA",
    LIGUE_1 = "LIGUE_1",
    CHAMPIONS_LEAGUE = "CHAMPIONS_LEAGUE",
    NATIONAL_TEAMS = "NATIONAL_TEAMS",
    UZBEKISTAN_LEAGUE = "UZBEKISTAN_LEAGUE",
    RETRO = "RETRO",
    OTHER = "OTHER",
    DISH = "DISH",
    DRINK = "DRINK"
}